import * as googleMaps from '@/common/googleMaps'

let _speedMarkers = []

const markerWidth = 30
const markerHeight = 30
const markerX = markerWidth / 2
const markerY = markerWidth / 2
const markerR = markerWidth / 2
const markerFontSize = 13

const speedColorLookups = [
  { background: '#3949AB', text: '#E8EAF6' }, // 0
  { background: '#1E88E5', text: '#E3F2FD' }, // 1
  { background: '#039BE5', text: '#E1F5FE' }, // 2
  { background: '#00897B', text: '#E0F2F1' }, // 3
  { background: '#43A047', text: '#E8F5E9' }, // 4
  { background: '#7CB342', text: '#33691E' }, // 5
  { background: '#C0CA33', text: '#625a00' }, // 6
  { background: '#FDD835', text: '#bd5000' }, // 7
  { background: '#FFB300', text: '#FFF8E1' }, // 8
  { background: '#FB8C00', text: '#FFF3E0' }, // 9
  { background: '#F4511E', text: '#FBE9E7' } // 10
]

const getMarkerSVG = (speed, speedBgColor, speedTextColor) => {
  const svg = `
    <svg width="${markerWidth}" height="${markerHeight}" viewBox="0 0 ${markerWidth} ${markerHeight}" xmlns="http://www.w3.org/2000/svg">
      <circle cx="${markerX}" cy="${markerY}" r="${markerR}" fill="${speedBgColor}" />
      <text x="50%" y="50%" text-anchor="middle" fill="${speedTextColor}" font-family="Open Sans" font-size="${markerFontSize}" font-weight="bold" dy=".3em">${speed}</text>
    </svg>`
  return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg)
}

export const plotSpeedMarkers = (telemetry, maxSpeed, markerClickCallback = null) => {
  telemetry.forEach((position, positionIndex) => {
    let latLng = new google.maps.LatLng(position.gps.latitude, position.gps.longitude)
    let speedColorIndex = Math.round(position.gps.speed / maxSpeed * (speedColorLookups.length - 1))
    if (speedColorIndex > speedColorLookups.length - 1) {
      speedColorIndex = speedColorLookups.length - 1
    }
    const speedColor = speedColorLookups[speedColorIndex]

    let marker = new google.maps.Marker({
      position: latLng,
      map: googleMaps.map,
      optimized: false,
      zIndex: 10,
      icon: {
        url: getMarkerSVG(position.gps.speed, speedColor.background, speedColor.text),
        // anchor must be half of the scaled size
        anchor: new google.maps.Point(markerWidth / 2, markerHeight / 2),
        scaledSize: new google.maps.Size(markerWidth, markerHeight)
      }
    })

    marker._positionIndex = positionIndex
    if (markerClickCallback !== null) {
      marker._clickHandler = google.maps.event.addListener(marker, 'click', markerClickCallback)
    } else {
      marker._clickHandler = null
    }

    _speedMarkers.push(marker)
  })
}

export const clearSpeedMarkers = () => {
  _speedMarkers.forEach(marker => {
    if (marker._clickHandler !== null) {
      google.maps.event.removeListener(marker._clickHandler)
    }
    marker.setMap(null)
    marker = null
  })
  _speedMarkers = []
}



// WEBPACK FOOTER //
// ./src/maps/google/speedMarkers.js